<mat-dialog-content>
  <p class="title" *ngIf="data.title">{{data.title | translate}}</p>
  <p class="body" *ngIf="data.body">{{data.body | translate}}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button
          color="info-full"
          mat-dialog-close
  >
    {{'CANCEL' | translate}}
  </button>
  <button mat-raised-button
          color="primary-full"
          [mat-dialog-close]="true"
  >
    {{data.confirmButton || 'YES' | translate}}
  </button>
</mat-dialog-actions>
